import type { VenueSummary } from '../types';

export const normalizeOwnedPartnerVenue = (id: string, data: Record<string, unknown>): VenueSummary => ({
  id,
  name: String(data.name || ''),
  username: String(data.username || ''),
  logoUrl: typeof data.logoUrl === 'string' ? data.logoUrl : undefined,
  coverUrl: typeof data.coverUrl === 'string' ? data.coverUrl : undefined,
  category: String(data.category || ''),
  city: String(data.city || ''),
  address: String(data.address || ''),
  bio: String(data.bio || data.description || ''),
  tags: Array.isArray(data.tags) ? data.tags.filter((tag): tag is string => typeof tag === 'string') : [],
  followersCount: Number(data.followersCount || 0),
  postsCount: Number(data.postsCount || 0),
  upcomingCount: Number(data.upcomingCount || 0),
  pastCount: Number(data.pastCount || 0),
  ownerUid: typeof data.ownerUid === 'string' ? data.ownerUid : undefined,
  adminOnly: data.adminOnly === true,
});
